import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import ServicesPage from "@/pages/Services";
import HowItWorksPage from "@/pages/HowItWorks";
import CoachesPage from "@/pages/Coaches";
import FAQPage from "@/pages/FAQ";
import ContactPage from "@/pages/Contact";
import DownloadPage from "@/pages/Download";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";
import AdminServices from "@/pages/AdminServices";
import AdminUsers from "@/pages/AdminUsers";
import AdminOrders from "@/pages/AdminOrders";
import AdminAuditLog from "@/pages/AdminAuditLog";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CheckoutCancelled from "@/pages/CheckoutCancelled";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardHome from "@/pages/dashboard/DashboardHome";
import MyReviews from "@/pages/dashboard/MyReviews";
import Profile from "@/pages/dashboard/Profile";
import Workspace from "@/pages/dashboard/Workspace";
import CoachLayout from "@/pages/coach/CoachLayout";
import CoachDashboard from "@/pages/coach/CoachDashboard";
import CoachReview from "@/pages/coach/CoachReview";
import CoachEarnings from "@/pages/coach/CoachEarnings";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <SmoothScroll>
              <ScrollToTop />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/how-it-works" element={<HowItWorksPage />} />
                <Route path="/coaches" element={<CoachesPage />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/download" element={<DownloadPage />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/services" element={<AdminServices />} />
                <Route path="/admin/users" element={<AdminUsers />} />
                <Route path="/admin/orders" element={<AdminOrders />} />
                <Route path="/admin/audit-log" element={<AdminAuditLog />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                <Route path="/checkout/cancelled" element={<CheckoutCancelled />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/dashboard" element={<DashboardLayout />}>
                  <Route index element={<DashboardHome />} />
                  <Route path="my-reviews" element={<MyReviews />} />
                  <Route path="profile" element={<Profile />} />
                  <Route path="orders/:orderId" element={<Workspace />} />
                </Route>
                <Route path="/coach" element={<CoachLayout />}>
                  <Route index element={<CoachDashboard />} />
                  <Route path="earnings" element={<CoachEarnings />} />
                  <Route path="orders/:orderId" element={<CoachReview />} />
                </Route>
              </Routes>
            </SmoothScroll>
            <Toaster
              theme="dark"
              position="bottom-right"
              toastOptions={{
                style: {
                  background: "#0A0A14",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "#fff",
                  borderRadius: 0,
                  fontFamily: "Manrope, sans-serif",
                },
              }}
            />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
